'use client';

import { useRouter } from 'next/navigation';
import { IconArrowRight1, IconSearchNormal } from '@/features/icons';
import { useSearchModal } from '@/components/header/search';
import { toNumberCommas } from '@/utils/string-helpers';
import { usePageTitle } from '../_utils/use-page-title';
import usePLPData from '../_utils/use-plp-data';
const PlpHeader = () => {
  const router = useRouter();
  const title = usePageTitle();
  const {
    pageResponse,
    isLoading,
    isPending
  } = usePLPData();
  const totalCount = pageResponse?.products?.totalCount;
  const {
    open
  } = useSearchModal();
  const goBack = () => {
    router?.back();
  };
  return <div className='sticky top-0 z-[1001] mb-2 flex h-14 flex-1 items-center bg-white px-2 py-3 shadow-sm lg:hidden' data-sentry-component="PlpHeader" data-sentry-source-file="plp-header.tsx">
            <div className='flex w-full items-center gap-2'>
                <IconArrowRight1 className='inline h-6 w-6 shrink-0 cursor-pointer text-text-black' onClick={goBack} data-sentry-element="IconArrowRight1" data-sentry-source-file="plp-header.tsx" />
                <h1 className='truncate text-sm font-bold text-text-black'>{title}</h1>
                {isLoading || isPending ? <div className='flex-1'>
                        <div className='h-5 w-14 animate-pulse rounded bg-gray-100'></div>
                    </div> : <span className='flex-1 whitespace-nowrap text-sm text-text-mediumGray'>
                        (<span data-test='plp-total-count'>{toNumberCommas(totalCount ?? 0)}</span> کالا)
                    </span>}
                <IconSearchNormal className='mr-2 h-6 w-6 shrink-0' onClick={open} data-sentry-element="IconSearchNormal" data-sentry-source-file="plp-header.tsx" />
            </div>
        </div>;
};
export default PlpHeader;